<template>
  <div class="mt-3" id="Navigation">
    <div class="container-md">
      <div class="row">
        <ul class="nav nav-tabs nav-justified">
          <li class="col-auto col-lg-3 nav-item text-center">
            <router-link
              class="nav-link"
              :class="'nav-link-' + language"
              @click="resetSite"
              :to="{ name: 'default-diamond' }"
            >
              {{ $t("Main.text.standard") }}
            </router-link>
          </li>
          <li class="col-auto col-lg-3 nav-item text-center">
            <router-link
              class="nav-link diamond-stock-nav-link"
              :class="'nav-link-' + language"
              @click="resetSite"
              :to="{ name: 'diamond-stock' }"
            >
              {{ $t("Main.text.stock") }}
            </router-link>
          </li>
          <li class="col-auto col-lg-3 nav-item text-center">
            <router-link
              class="nav-link lab-grown-nav-link"
              :class="'nav-link-' + language"
              @click="resetSite"
              :to="{ name: 'lab-grown' }"
            >
              {{ $t("Main.text.labGrown_1") }}
              <br class="d-sm-none d-md-inline-block d-lg-none" />
              {{ $t("Main.text.labGrown_2") }}
            </router-link>
          </li>
          <li
            class="col-auto col-lg-3 nav-item d-none d-md-inline-block text-center"
          >
            <a
              class="nav-link"
              :class="'nav-link-' + language"
              :href="
                country === language
                  ? '/diamanten/'
                  : '/' + language + '/diamanten/'
              "
            >
              {{ $t("Main.text.more") }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { computed } from "vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "navigation",

  setup() {
    function resetSite() {
      store.dispatch("setSearchData/setNavSite", 1);
    }

    return {
      resetSite,
      country: computed(() => {
        return (window.diamondStockConfig.country !== "") ? window.diamondStockConfig.country : 'de';
      }),
      language: computed(() => {
        return window.diamondStockConfig.language !== ""
          ? window.diamondStockConfig.language
          : "de";
      }),
    };
  },
};
</script>

<style lang="scss">
#Navigation {
  .nav {
    &.nav-tabs {
      border-bottom: none;

      .nav-item {
        .nav-link {
          color: #333;
          padding: 0.5rem 1.25rem;
          font-size: 1.6rem;
          text-decoration: underline;

          &.router-link-active {
            color: $realDiamondColor;
            border-color: $realDiamondColor $realDiamondColor $greyColor;

            &.lab-grown-nav-link {
              color: $labGrownColor;
              border-color: $labGrownColor $labGrownColor $greyColor;
            }
          }

          &.nav-link-en {
            @media #{$sm} {
              padding: 0.5rem 0.75rem;
            }

            @media #{$md} {
              padding: 0.5rem 3rem;
            }

            @media #{$lg} {
              padding: 1rem 4rem;
            }

            @media #{$xl} {
              padding: 1rem 5.5rem;
            }
          }

          &.nav-link-nl {
            @media (min-width: 381px) and (max-width: 440px) {
              padding: 0.5rem 1.75rem;
            }

            @media (min-width: 461px) and (max-width: 540px) {
              padding: 0.5rem 3rem;
            }

            @media (min-width: 541px) and (max-width: 650px) {
              padding: 0.5rem 4rem;
            }

            @media (min-width: 651px) and (max-width: 767px) {
              padding: 0.5rem 0;
            }

            @media #{$md} {
              padding: 0.5rem 3.5rem;
            }

            @media #{$lg} {
              padding: 1rem 3rem;
            }

            @media #{$xl} {
              padding: 1rem 4.5rem;
            }
          }

          @media (max-width: 379px) {
            padding: 0.5rem 0.25rem;
          }

          @media (min-width: 500px) {
            padding: 0.5rem 3.25rem;
          }

          @media #{$sm} {
            padding: 0.5rem 0.75rem;
          }

          @media #{$md} {
            padding: 0.5rem 3rem;
          }

          @media #{$lg} {
            padding: 1rem 2.5rem;
          }

          @media #{$xl} {
            font-size: 1.8rem;
            padding: 1rem 3.5rem;
          }
        }
      }

      &.nav-justified {
        .nav-item,
        & > .nav-link {
          flex-basis: 0;
          flex-grow: 1;

          @media #{$lg} {
            flex-grow: 0;
            flex-basis: auto;
          }
        }
      }

      @media #{$lg} {
        display: inline-flex;
      }
    }
  }

  @media (max-width: 374px) {
    font-size: 1.2rem;
  }
}
</style>
